<template>
  <View align="center" justify="center" class="file-thumbnail">
    <template v-if="!isLoading">
      <img v-if="thumbnailUrl && !isUnableToLoad" :src="thumbnailUrl" @error="onError" />

      <Icon v-else :name="isUnableToLoad ? 'image-x' : 'file-04'" />
    </template>

    <LoadingIndicator v-else />

    <slot />
  </View>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Icon, LoadingIndicator, View } from '@tallo/design-system';

defineProps<{ thumbnailUrl?: string | null; isLoading?: boolean }>();

const isUnableToLoad = ref(false);

function onError() {
  isUnableToLoad.value = true;
}
</script>

<style scoped lang="scss">
.file-thumbnail {
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
  background-color: var(--t-color-neutral-200);
  border-radius: var(--t-border-radius-sm);
  color: var(--t-color-neutral-500);
  overflow: hidden;
  flex-shrink: 0;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>
